import {CardStatus} from '@pleo-io/deimos'

export const isUnpaired = (status: CardStatus, daysToExpiration: number): boolean => {
    return status === CardStatus.DEACTIVATED && daysToExpiration > 0
}

export const isPaired = (
    status: CardStatus,
    daysToExpiration: number,
    employeeId: string | null,
): boolean => {
    return status === CardStatus.LIVE && daysToExpiration > 0 && employeeId !== null
}

export const isExpiring = (aboutToExpire: boolean, daysToExpiration: number): boolean => {
    return aboutToExpire && daysToExpiration > 0
}

export const isFrozen = (
    status: CardStatus,
    daysToExpiration: number,
    employeeId: string | null,
): boolean => {
    return status === CardStatus.RESTRICTED && daysToExpiration > 0 && employeeId !== null
}

export const isExpired = (daysToExpiration: number): boolean => {
    return daysToExpiration <= 0
}

export const isLost = (status: CardStatus, daysToExpiration: number): boolean => {
    return status === CardStatus.LOST && daysToExpiration > 0
}

export const isStolen = (status: CardStatus, daysToExpiration: number): boolean => {
    return status === CardStatus.STOLEN && daysToExpiration > 0
}

export const isLostOrStolen = (status: CardStatus, daysToExpiration: number): boolean => {
    return isLost(status, daysToExpiration) || isStolen(status, daysToExpiration)
}
